import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Box,
  ClickAwayListener,
  Divider,
  List,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  ListItem,
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Alert,
  Snackbar,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useContext, useEffect, useState } from "react";
import Joyride, { ACTIONS, STATUS } from "react-joyride";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import { UserInfo } from "../../model";
import { UserLoginInfo } from "../../types/context";
import { Http, appLogger } from "../../utils";
import DeleteDialog from "../../utils/common/DeleteDialog";
import CloseIcon from "@mui/icons-material/Close";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconWithToolTip } from "../common";
import { getDateTime } from "../../utils/data";
import SearchIcon from "@mui/icons-material/Search";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

const ListAccount = () => {
  const navigate = useNavigate();
  const [products, setProducts] = React.useState([] as any);

  const [searchProducts, setSearchProducts] = React.useState([] as any);
  const {
    userInfo,
    setProVersion,
    setcontextProVersion,
    setcontextRedirectProdPage,
    BasicDetailAccordianContext,
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    setQRSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;
  const [orderBy, setOrderBy] = useState("modified");
  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const [itemLimit, setItemLimit] = useState({
    lowerLimit: 0,
    upperLimit: 9,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = React.useState("");
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const [deleteTxt, setDeleteTxt] = useState("");
  const [currProd, setCurrProd] = useState({} as any);
  const [deleteEnable, setDeleteEnable] = useState(false);
  const [deleteID, setDeleteID] = useState([] as any);
  setOrder;
  setBasicDetailAccordianContext(true);
  setGenSettingsAccordianContext(false);
  setFbSettingsAccordianContext(false);
  setBugSettingsAccordianContext(false);
  setFreqSettingsAccordianContext(false);
  setEmailSettingsAccordianContext(false);
  setExttrackingSettingsAccordianContext(false);
  setWidgAppSettingsAccordianContext(false);
  setWidgIntgSettingsAccordianContext(false);
  setQRSettingsAccordianContext(false);
  const [run, setRun] = useState(false);

  const [integrateProduct, setIntegrateProduct] = useState(false);

  const handleToggleIntegrateProduct = () => {
    setIntegrateProduct((prevState) => !prevState);
  };

  const setDeleteHandle = (e: any) => {
    setDeleteTxt(e.target.value);
    setDeleteEnable(false);

    if (e.target.value.toLowerCase() == "delete") {
      setDeleteEnable(true);
    }
  };

  const clearInput = () => {
    setDeleteTxt("");
    setDeleteEnable(false);
  };

  const handleMenuOpen = (event: any, prod: any) => {
    setAnchorEl(event.currentTarget);
    setCurrProd(prod);
  };

  const handleClickOpen = (product: any) => {
    appLogger.info({
      infoObj: {
        method: "handleClickOpen",
        component: "products",
        fileName: "manage.tsx",
        setToDelete: product,
      },
    });
    setDeleteID(product);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (event.target.value === "-1") {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: products.length - 1,
      });
    } else {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: parseInt(event.target.value, 10) - 1,
      });
    }
  };

  const handleRequestSort = (property: string) => {
    if (orderBy === property) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrder("asc");
      setOrderBy(property);
    }
  };

  const fetchData = () => {
    Http.get({
      url: `/api/v2/products/0`,
      state: userInfo,
    })
      .then((response: any) => {
        if (response && response.productNameList.length == 0) {
          openGuidedtour();
        }
        appLogger.info({
          infoObj: {
            method: "fetchData",
            component: "products",
            fileName: "manage.tsx",
            productResponse: response,
          },
        });

        const GroupedByBlock = [
          ...new Set(
            response?.productNameList
              ?.sort(compareModifiedDesc)
              .map((item: any) => item.id)
          ),
        ];
        appLogger.info({
          infoObj: {
            method: "fetchData",
            component: "products",
            fileName: "manage.tsx",
            GroupedByBlock: GroupedByBlock,
          },
        });

        const tempArray: any = [];

        if (GroupedByBlock && GroupedByBlock.length) {
          GroupedByBlock.forEach((v, i) => {
            const respArray = response.productNameList;
            const sortArr = respArray.sort(compareModifiedDesc);
            const newArray = sortArr.filter(function (el: any) {
              return el.id == v;
            });

            const arrayObj = {
              name: newArray[0].name,
              fields: newArray,
            };
            tempArray.push(arrayObj);
          });
        }

        setProducts(tempArray);

        // const groupBy = (array: any, key: any) => {
        //   return array.reduce((result: any, currentValue: any, i: any) => {
        //     (result[currentValue.orgId] =
        //       result[currentValue.orgId] || []).push(currentValue);
        //     return result;
        //   }, []);
        // };
        // const groupedByProduct = groupBy(response.productNameList, "orgId");

        // setProducts(groupedByProduct);

        // setProducts(response.productNameList);
        setSearchProducts(tempArray);
        setIsloading(false);
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "fetchData",
            component: "products",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
      });
  };
  const openGuidedtour = () => {
    setRun(!run);
  };
  const renderGuidedSteps: any = () => {
    const steps: any = [
      {
        disableBeacon: true,
        hideFooter: true,
        placement: "right",
        spotlightClicks: true,
        styles: {
          options: {
            zIndex: 10000,
          },
        },
        target: ".add-pro-link",
        content: (
          <div>
            <h3 className="guidesteptitle">Create a account</h3>
            <h4 className="guidestepsubtitle" style={{ marginBottom: "7px" }}>
              Please go to Add New Account to create your account
            </h4>
          </div>
        ),
      },
    ];
    return steps;
  };
  const handleJoyrideCallback = (data: any) => {
    const { action, index, status, type } = data;
    if (
      status == STATUS.FINISHED ||
      action == ACTIONS.CLOSE ||
      action == ACTIONS.SKIP
    ) {
      setRun(false);
    }
  };
  useEffect(() => {
    setIsloading(true);
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      products.length < 1
    ) {
      fetchData();
    }
  }, [userInfo]);

  useEffect(() => {
    if (alertOpen) {
      fetchData();
    }

    // setProducts(products);
  }, [alertOpen, errorAlertOpen]);

  const feedbackLink = (product: any) => {
    // navigate("Feedback", { product: any });
    navigate("/feedback", { state: product });
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const deleteProduct = () => {
    appLogger.info({
      infoObj: {
        method: "deleteProduct",
        component: "products",
        fileName: "manage.tsx",
        deleteID: deleteID,
      },
    });

    // products.map((e: any, i: any) => {
    //   if (e.fields.length == 1) {
    //     if (e.fields[0].id == deleteID.id) {
    //       products.splice(products.indexOf(i), 1);
    //     }
    //   } else {
    //     e.fields.map((del: any, ind: number) => {
    //       if (del.id == deleteID.id) {
    //         products.splice(e.fields.indexOf(ind), 1);
    //       }
    //     });
    //   }
    // });

    setIsloading(true);
    Http.deleteReq({
      url: `/api/v2/products/${deleteID.id}/${deleteID.version}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteProduct",
            component: "products",
            fileName: "manage.tsx",
            deleteProductResponse: response,
          },
        });
        setOpen(false);
        setIsloading(false);
        setAlertOpen(true);
        setProducts(products.filter((e: any) => e.id != deleteID.id));
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "deleteProduct",
            component: "products",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpen(true);
      });
  };

  function compareProduct(a: any, b: any) {
    return a.name.localeCompare(b.name);
  }

  function compareProductDesc(a: any, b: any) {
    return b.name.localeCompare(a.name);
  }

  function compareVersion(a: any, b: any) {
    return a.version.localeCompare(b.version);
  }

  function compareVersionDesc(a: any, b: any) {
    return b.version.localeCompare(a.version);
  }

  function comparePlatform(a: any, b: any) {
    return a.platform.localeCompare(b.platform);
  }

  function comparePlatformDesc(a: any, b: any) {
    return b.platform.localeCompare(a.platform);
  }

  function compareModified(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return 1;
    }
    if (!a.lastModifiedOn) {
      return -1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? -1 : 1;
  }

  function compareModifiedDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return -1;
    }
    if (!a.lastModifiedOn) {
      return 1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? 1 : -1;
  }

  useEffect(() => {
    if (products.length > 0) {
      const tempSortedProducts = [...products];
      if (order === "asc") {
        if (orderBy === "product") {
          setProducts(tempSortedProducts.sort(compareProduct));
        } else if (orderBy === "version") {
          setProducts(tempSortedProducts.sort(compareVersion));
        } else if (orderBy === "platform") {
          setProducts(tempSortedProducts.sort(comparePlatform));
        } else if (orderBy === "modified") {
          setProducts(tempSortedProducts.sort(compareModified));
        }
      }
      if (order === "desc") {
        if (orderBy === "product") {
          setProducts(tempSortedProducts.sort(compareProductDesc));
        } else if (orderBy === "version") {
          setProducts(tempSortedProducts.sort(compareVersionDesc));
        } else if (orderBy === "platform") {
          setProducts(tempSortedProducts.sort(comparePlatformDesc));
        } else if (orderBy === "modified") {
          setProducts(tempSortedProducts.sort(compareModifiedDesc));
        }
      }
    }
  }, [order, orderBy]);

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      setSearchKeyword(search);
      e.preventDefault();
    }
  };

  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = searchProducts;
      const filteredRows = temp.filter((row: { name: string }) => {
        return row.name.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setProducts(filteredRows);
    } else {
      setProducts(searchProducts);
    }
  };

  const searchClear = () => {
    setSearch("");
    setProducts(searchProducts);
  };

  const menuId = "clone-menu";

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderMenu = (e: any) => {
    return (
      <ClickAwayListener onClickAway={handleMenuClose}>
        <Menu
          sx={{
            mt: "25px",
            textTransform: "capitalize",
          }}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          className=" pro-menu copy-paste-popover"
          keepMounted
          id={menuId}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={isMenuOpen}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              boxShadow: "0px 1px 1px #dedede59",
              filter: "drop-shadow(0px 1px 2px #dedede59)",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
        >
          <MenuItem
            onClick={() => {
              currProd.cloneNewProduct = true;
              navigate("/add-account", { state: currProd });
            }}
          >
            <Typography style={{ textTransform: "none", fontSize: "13px" }}>
              Clone as new product
            </Typography>
          </MenuItem>
          <Divider className="prod-copy-divider" sx={{ marginBottom: "0px" }} />
          <MenuItem
            onClick={() => {
              currProd.cloneNewVersion = true;
              navigate("/add-account", { state: currProd });
            }}
          >
            <Typography style={{ textTransform: "none", fontSize: "13px" }}>
              Clone as new version
            </Typography>
          </MenuItem>
        </Menu>
      </ClickAwayListener>
    );
  };

  const viewDashboard = (val: any) => {
    navigate("/dashboard");
    setProVersion({
      product: val.id,
      version: val.version,
    });
    setcontextProVersion([
      {
        value: val.id,
        title: val.name,
        version: val.version,
        proversion: val.name + val.version,
      },
    ]);
  };
  useEffect(() => {
    setcontextRedirectProdPage(true);
  }, []);

  return (
    <Box className={isLoading ? "table loader" : "table"}>
      <Grid className="manage-search" container spacing={2}>
        <Grid item xs={12} md={4} lg={2} sx={{ mb: 1 }}>
          <FormControl className="custom-select">
            <InputLabel>Search</InputLabel>
            <OutlinedInput
              type="text"
              value={search}
              onChange={handleSearchTyping}
              onKeyPress={handleKeyPress}
              id="search-input"
              endAdornment={
                <>
                  {search && (
                    <InputAdornment position="end" onClick={searchClear}>
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <CloseIcon className="cursor-pointer" />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton aria-label="search icon" edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              }
              label="Search"
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box className="products-table table-wrap">
        <Table sx={{ mb: 3 }}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "product"}
                  direction={orderBy === "product" ? order : "asc"}
                  onClick={() => {
                    handleRequestSort("product");
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Accounts</Typography>
                  <span
                    className={
                      orderBy === "product"
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>
                <Typography>Platform</Typography>
              </TableCell> */}
              <TableCell>
                <Typography>Modified</Typography>
              </TableCell>
              <TableCell>
                <Typography>Action</Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(rowsPerPage > 0
              ? products.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : products
            ).map((product: any, index: number) => {
              if (index < itemLimit.lowerLimit) {
                return;
              }
              if (index > itemLimit.upperLimit) {
                return;
              }

              return (
                <TableRow key={index}>
                  <TableCell className="pro-title">
                    {product.logo && (
                      <img className="prod-logo" src={product.logo} />
                    )}

                    {!product.logo && (
                      <Typography className="prod-logo-txt">
                        {product.name[0]}
                      </Typography>
                    )}

                    <Typography>{product.name}</Typography>

                    {product.fields.map((e: any) => {
                      return (
                        <Typography
                          sx={{
                            mt: 1,
                            textDecoration: "underline",
                            color: "#0157ff !important",
                            cursor: "pointer",
                          }}
                          onClick={() => navigate("/add-account", { state: e })}
                        >
                          {e.version}
                        </Typography>
                      );
                    })}
                  </TableCell>

                  {/* <TableCell>
                    {product.fields.map((e: any) => {
                      return (
                        <Typography sx={{ mt: 1 }}>{e.platform}</Typography>
                      );
                    })}
                  </TableCell> */}

                  <TableCell>
                    {product.fields.map((e: any) => {
                      return (
                        <Typography sx={{ mt: 1 }}>
                          {getDateTime(e.lastModifiedOn)}
                        </Typography>
                      );
                    })}
                  </TableCell>

                  <TableCell>
                    {product.fields.map((e: any) => {
                      return (
                        <List
                          className="table-options"
                          sx={{ display: "flex" }}
                        >
                          <ListItem onClick={() => viewDashboard(e)}>
                            <ListItemText
                              primary={
                                <IconWithToolTip
                                  message="View Dashboard"
                                  iconName="icon-dashboard"
                                />
                              }
                            />
                          </ListItem>
                          <ListItem
                            onClick={() =>
                              navigate("/add-account", { state: e })
                            }
                          >
                            <ListItemText
                              primary={
                                <IconWithToolTip
                                  message="Edit Account"
                                  iconName="icon-edit"
                                />
                              }
                            />
                          </ListItem>
                          <ListItem
                            onClick={(event) => {
                              handleMenuOpen(event, e);
                            }}
                            aria-controls={menuId}
                            aria-haspopup="true"
                          >
                            <ListItemText
                              primary={
                                <>
                                  <IconWithToolTip
                                    message="Copy Account"
                                    iconName="icon-copy-1"
                                  />
                                  <KeyboardArrowDownIcon
                                    style={{ fontSize: "12px" }}
                                  />
                                </>
                              }
                            />
                            {isMenuOpen && renderMenu(e)}
                          </ListItem>
                          <ListItem>
                            <ListItemText
                              primary={
                                <IconWithToolTip
                                  message="Delete Account"
                                  iconName="icon-delete"
                                />
                              }
                              onClick={() => handleClickOpen(e)}
                            />
                          </ListItem>
                        </List>
                      );
                    })}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 15, 20]}
          count={products.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Box>
      {open && (
        <DeleteDialog
          deletepopupShow={open}
          deletepopupClose={handleClose}
          handleDeleteConfirm={deleteProduct}
          type="product"
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity="success">
          product deleted successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpen}
        autoHideDuration={2000}
        onClose={handleErrorAlertClose}
      >
        <Alert onClose={handleErrorAlertClose} severity="error">
          Error in product delete !!!
        </Alert>
      </Snackbar>
      <Joyride
        locale={{
          open: "Click to see the steps",
        }}
        run={run}
        callback={handleJoyrideCallback}
        disableScrolling
        styles={{
          options: {
            // modal arrow and background color
            arrowColor: "#0157ff",
            backgroundColor: "#0157ff",
            // page overlay color
            overlayColor: "#4f4f4f",
            //button color
            primaryColor: "#d68520",
            //text color
            textColor: "#fff",

            //width of modal
            width: 300,
            //zindex of modal
            zIndex: 1000,
          },
        }}
        continuous
        showProgress
        showSkipButton
        steps={renderGuidedSteps()}
      />
    </Box>
  );
};

export default ListAccount;
